import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunSourceRemovalFailedAction = {
	type: 'WORKFLOW_RUN_SOURCE_REMOVAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunSourceRemovalFailedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_REMOVAL_FAILED',
	payload,
});
